import React, { Component } from 'react'
import EditUserForm from '../../../components/SiteAdmin/EditUserForm/EditUserForm';
import { graphql } from 'react-apollo'
import { flowRight as compose } from 'lodash';
import getUser from './getUser.graphql';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './EditUser.css';
import Loader from '../../../components/Common/Loader/Loader';

export class EditUser extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
    };

    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getUser }, data, id } = this.props;

        let initialValues = {};

        if (!loading && getUser) {
            initialValues = {
                id: getUser.id,
                firstName: getUser.profile.firstName,
                lastName: getUser.profile.lastName,
                email: getUser.email,
                phoneDialCode: getUser.phoneDialCode,
                phoneNumber: getUser.phoneNumber,
                userStatus: getUser.userStatus,
                isBan: getUser.isBan,
                country: getUser.profile.country,
                phoneCountryCode: getUser.phoneCountryCode,
                picture: getUser.profile.picture
            }
        }


        if (loading) {
            return <div><Loader type={"page"} show={loading}></Loader></div>
        } else {
            return (
                <div>
                    <EditUserForm initialValues={initialValues} />
                </div>
            )
        }
    }
}



export default compose(withStyles(s),graphql(getUser, {
    options: (props) => ({
        variables: {
            id: props.id
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
}))(EditUser)
